import { render, staticRenderFns } from "./AuditRelationTable.vue?vue&type=template&id=535741fb"
import script from "./AuditRelationTable.vue?vue&type=script&lang=js"
export * from "./AuditRelationTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports